module.exports = __webpack_public_path__ + "static/media/view talent category.fa714510.svg";